import React, { Fragment, useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import Dropdown from "react-bootstrap/Dropdown";
import AxisSpinner from "./AxisSpinner";
import Select from "react-select";

const CertSelection = ({
  defaultValue,
  onSelected,
  placeholderText = "All Certificates",
  disabled = false,
}) => {
  const { authAxios } = useAuth();
  const [disableButton, setDisableButton] = useState(disabled);
  const [loading, setLoading] = useState(false);
  const [certs, setCerts] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    getCertificates();
  }, []);

  useEffect(() => {
    if (defaultValue === null || defaultValue === undefined) return;

    setSelected(defaultValue);
  }, [defaultValue]);

  const getCertificates = async () => {
    try {
      setLoading(true);

      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: {},
      };

      const response = await authAxios().get(
        "/api/backoffice/certs/certificates",
        config,
      );
      setCerts(response.data);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Error catch");
      console.log(error);
      console.log(error.stack);
    }
  };

  const selectCert = (cert) => {
    setSelected(cert);
    onSelected(cert);
  };

  const getLabel = (cert) => {
    return cert?.name;
  };

  return (
    <Fragment>
      <Select
        options={certs}
        onChange={(data) => {
          selectCert(data);
        }}
        isClearable={true}
        getOptionLabel={getLabel}
        value={selected}
        placeholder={placeholderText}
        isDisabled={disabled}
      />
    </Fragment>
  );
};

export default CertSelection;
